import { Dispatch, SetStateAction } from 'react';
import {
  FlexBetween,
  FlexJustifyCenter,
  HubLengthMessage
} from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import {
  CLUB,
  LP,
  MLP,
  USDT,
  formatUSD
} from '../../../helpers/helperFunctions';
import { Button } from '../../../styles/GlobalComponents';
import { InvoiceHeader, Invoices, InvoicesMobile } from '../AccountingStyled';

interface TransactionsPageType {
  transactions: any;
  countTransactions: number;
  setCountTransactions: Dispatch<SetStateAction<number>>;
}

export const TransactionsPage = ({
  transactions,
  countTransactions,
  setCountTransactions
}: TransactionsPageType) => {
  const { t } = useTranslation('accounting');

  const TransactionType = (type: number) => {
    switch (type) {
      case 1:
        return 'withdraw';
      case 2:
        return 'commission';
      case 3:
        return 'lp conversion';
      case 4:
        return 'mlp bonus';
      case 5:
        return 'extraordinary bonus';
      default:
        return '';
    }
  };

  const transactionStatus = (status: number) => {
    switch (status) {
      case 1:
        return t('processing');
      case 2:
        return t('completed');
      case 3:
        return t('refunded');
      default:
    }
  };

  return (
    <AnimatedTab key={'TransactionsPage'}>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '20%' }}>{t('date')}</div>
          <div style={{ width: '20%' }}>{t('transaction_id')}</div>
          <div style={{ width: '20%' }}>{t('type')}</div>
          <div style={{ width: '20%' }}>{t('amount')}</div>
          <div style={{ width: '20%' }}>{t('status')}</div>
        </InvoiceHeader>
      </Desktop>

      {transactions?.length === 0 ? (
        <HubLengthMessage>{t('no_invoices')}</HubLengthMessage>
      ) : (
        transactions?.map((inv: any, i: number) => {
          const type = inv.groupType;

          const TransactionTypeAmount = () => {
            switch (type) {
              case 1:
                return `${formatUSD(inv.rewardPoints || 0)} ${USDT}`;
              case 2:
                return (
                  <div>
                    {`${formatUSD(inv.rewardPoints || 0)} ${USDT}`}
                    <br />

                    {`${formatUSD(inv.shoppingPoints || 0)} ${CLUB}`}
                    <br />

                    {`${formatUSD(inv.myLifePoints || 0)} ${MLP}`}
                    <br />

                    {`${formatUSD(inv.ulxPoints || 0)} BONUS HUB`}
                  </div>
                );
              case 3:
                return `${formatUSD(inv.loyaltyPoints || 0)} ${inv.currency}`;
              case 4:
                return `${formatUSD(inv.myLifePoints || 0)} ${inv.currency}`;

              case 5:
                return (
                  <div>
                    {`${formatUSD(inv.rewardPoints || 0)} ${USDT}`}
                    <br />

                    {`${formatUSD(inv.shoppingPoints || 0)} ${CLUB}`}
                    <br />

                    {`${formatUSD(inv.loyaltyPoints || 0)} ${LP}`}
                    <br />

                    {`${formatUSD(inv.myLifePoints || 0)} ${MLP}`}
                    <br />
                  </div>
                );
              case null:
                return ``;
              default:
                return '';
            }
          };

          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '20%' }}>
                    {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '20%' }}>#{inv.id}</div>
                  <div style={{ width: '20%' }}>
                    {TransactionType(inv.groupType)}
                  </div>
                  <div style={{ width: '20%' }}>
                    <span> {TransactionTypeAmount()}</span>
                  </div>
                  <div style={{ width: '20%' }}>
                    {transactionStatus(inv.status)}
                  </div>
                </Invoices>
              </Desktop>
              <Mobile>
                <InvoicesMobile>
                  <FlexBetween>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px'
                      }}>
                      {TransactionType(inv.groupType)}
                    </div>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px',
                        fontSize: 18
                      }}>
                      {TransactionTypeAmount()}
                    </div>
                  </FlexBetween>
                  <FlexBetween>
                    <div>
                      {moment.utc(inv?.dateCreated).format('DD/MM/YY')} • #
                      {inv.id}
                    </div>
                    <div
                      style={{
                        color: '#B5A8A8',
                        lineHeight: '18px',
                        fontSize: 12
                      }}>
                      {transactionStatus(inv.status)}
                    </div>
                  </FlexBetween>
                </InvoicesMobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
      {transactions?.length >= 50 &&
        transactions?.length === countTransactions && (
          <FlexJustifyCenter>
            <Button
              w='200px'
              mt='10'
              mb='20'
              onClick={() => setCountTransactions((count) => count + 50)}>
              {t('show_more')}
            </Button>
          </FlexJustifyCenter>
        )}
    </AnimatedTab>
  );
};
